import { IconProps } from "./type";

const WithdrawIcon = (_props: IconProps) => {
  return (
    <svg
      width="66"
      height="66"
      viewBox="0 0 66 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <foreignObject x="0" y="0" width="0" height="0">
        <div xmlns="http://www.w3.org/1999/xhtml"></div>
      </foreignObject>
      <circle
        data-figma-bg-blur-radius="4"
        cx="33"
        cy="33"
        r="32.5"
        transform="rotate(-180 33 33)"
        fill="#D5EAFF"
        stroke="#D5EAFF"
      />
      <path
        d="M28.4287 19.2852H42.143"
        stroke="#215589"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M24.7576 41.8882L41.7281 24.9176M42.5363 37.0395V24.1095H29.6063"
        stroke="#215589"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <clipPath id="bgblur_0_259_39758_clip_path" transform="translate(0 0)">
          <circle cx="33" cy="33" r="32.5" transform="rotate(-180 33 33)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default WithdrawIcon;
